export const styles = () => ({
  root: {
    padding: "12px 20px"
  },
  selectedPlaceholder: {
    marginTop: 2,
    fontSize: 14,
    fontWeight: 600,
    color: "#333333",
    opacity: "0.75"
  },
  placeholder: {
    color: "#333333",
    fontSize: 14,
    marginTop: 2,
    fontWeight: 600,
    opacity: "0.75"
  },
  openOpacity: {
    opacity: "1"
  },
  tableHeader: {
    fontFamily: 'Open Sans',
    fontWeight: 600,
    fontSize: 14,
    lineHeight: '20px',
    color: '#333333',
    position: "sticky",
    top: -1,
  },
  tableCell: {
    padding: '12px 16px',
    verticalAlign: 'middle',
    height: 52
  },
  tableText: {
    fontSize: 14,
    lineHeight: '20px',
    textAlign: 'left',
    color: '#333333',
  },
  bottomView: {
    height: "58vh"
  },
  tableContainerRoot: {
    borderTop: "0.5px solid #dadada",
    height: "52vh",
    overflowY: "auto",
    borderBottom: "none",
  },
  boxStyles: {
    display: "flex",
    alignItems: "center",
    marginTop: 8,
    width: 140
  },
  // boxStylesDropDown: {
  //   width: "95px",
  //   border: "1px solid rgb(218, 218, 218)",
  //   height: 32,
  //   padding: "0px 13px",
  //   "&:hover": {
  //     border: "1px solid #26bbed",
  //   }
  // },
  rightPadding: {
    paddingRight: 20
  },
  bottomViewCampaignAll: {
    height: "77vh",
    marginTop: 24
  },
  bottomViewProperty: {
    height: "58vh",
    marginTop: 24
  },
  tableContainerCampaignRoot: {
    borderTop: "0.5px solid #dadada",
    height: "72vh",
    overflowY: "auto",
    borderBottom: "0.5px solid #dadada",
  },
  allCampaignHeader: {
    color: "rgba(0, 0, 0, 1)",
    fontFamily: "Open Sans",
    fontSize: 16,
    lineHeight: "36px",
    marginBottom: 16
  },
  boxStylesCampaign: {
    display: "flex",
    alignItems: "center",
    marginTop: 8,
    width: 163
  },
  boxStylesProperty: {
    display: "flex",
    alignItems: "center",
    marginTop: 8,
    width: 314
  },
  campaignSelect: {
    cursor: "pointer",
    "&:hover": {
      color: "#26bbed"
    }
  },
  emailLink: {
    cursor: "pointer",
    color: "#4F6FAE",
    "&:hover": {
      color: "#26bbed"
    }
  },
  firstColumnWeight: {
    fontWeight: 600
  }
})

